import { useEffect, useState } from 'react';

export const MEDIA_QUERIES = {
  LARGE_DESKTOP: '2400px',
  DESKTOP: '1920px',
  SMALL_DESKTOP: '1660px',
  DESKTOP_15INCH: '1440px',
  DESKTOP_13INCH: '1280px',
  LARGE_TABLET: '1024px',
  TABLET: '840px',
  SMALL_TABLET: '620px',
  MOBILE: '480px',
  SMALL_MOBILE: '380px'
};

export function useMediaQuery(query: string) {
  const getMatches = (query: string): boolean => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  };

  const [matches, setMatches] = useState<boolean>(getMatches(query));

  const handleChange = () => {
    setMatches(getMatches(query));
  };

  useEffect(() => {
    const matchMedia = window.matchMedia(query);
    handleChange();
    matchMedia.addEventListener('change', handleChange);

    return () => {
      matchMedia.removeEventListener('change', handleChange);
    };
  }, [query]);

  return [matches];
}
